import { t } from "i18next";
import CombustionIcon from "../icons/CombustionIcon";
import ElectricityIcon from "../icons/ElectricityIcon";
import RechargesIcon from "../icons/RechargesIcon";
import VehicleIcon from "../icons/VehicleIcon";
import { DashboardMeasureCard } from "./DashboardMeasureCard";

export const DashboardCo2Data = ({ co2Data }: any) => {
  return (
    <>
      <div className="font-semibold text-[22px] py-2">
        {t("dashboard.categories")}
      </div>
      <div className="bg-transparent">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {/* Combustion */}
          <DashboardMeasureCard
            title="combustion.title"
            value={co2Data.breakdown.combustion}
            icon={<CombustionIcon width={50} height={50} />}
            bg="bg-lime-600"
          />
          {/* Vehicles/Consumption */}
          <DashboardMeasureCard
            title="vehicles.consumption.title"
            value={co2Data.breakdown.consumption}
            icon={<VehicleIcon width={50} height={50} />}
            bg="bg-lime-600"
          />
          {/* Recharges/Emission */}
          <DashboardMeasureCard
            title="recharges.title"
            value={co2Data.breakdown.emission}
            icon={<RechargesIcon width={50} height={50} />}
            bg="bg-lime-600"
          />
          {/* Electricity */}
          <DashboardMeasureCard
            title="electricity.title"
            value={co2Data.breakdown.electricity}
            icon={<ElectricityIcon width={50} height={50} />}
            bg="bg-lime-400"
          />
        </div>
      </div>
    </>
  );
};
